import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[applyTopHeaderContent]'
})
export class TopHeaderDirective {

  constructor(public templateRef: TemplateRef<unknown>) { }

}
